<article
  class="notification-item"
  [class.notification-item--panel]="variant === 'panel'"
  [class.notification-item--page]="variant === 'page'"
  [class.notification-item--unread]="notification?.readAt === null"
  tabindex="0"
  role="button"
  (click)="openNotification($event)"
  (keydown.enter)="openNotification($event)"
>
  <app-thumbnail
    classList="notification-item__thumbnail"
    size="md"
    [circle]="true"
    [imgSrc]="thumbnail | mediaObject: thumbnailOptions"
  ></app-thumbnail>
  <div class="notification-item__content">
    <div class="notification-item__header">
      <button type="button" class="notification-item__author" (click)="openAuthor($event)">
        {{ notification?.fromUser?.username }}
      </button>
      <small>{{ notification?.createdAt | dateAgo }}</small>
    </div>
    <p class="notification-item__message">{{ message }}</p>
    <div *ngIf="isPendingOwnerInvitation" class="mt-2 flex gap-2">
      <button pButton type="button" [outlined]="true" [text]="true" [severity]="'primary'" [size]="'small'"
              [disabled]="!confirmationToken || invitationActionPending"
              (click)="confirmOwnerInvitation($event)">
        {{ 'common.confirm' | translate }}
      </button>
      <button pButton type="button" [outlined]="true" [text]="true" [severity]="'secondary'" [size]="'small'"
              [disabled]="!invitationId || invitationActionPending"
              (click)="denyOwnerInvitation($event)">
        {{ 'common.reject' | translate }}
      </button>
    </div>
    <div *ngIf="isPendingEventInvitation" class="mt-2 flex gap-2">
      <button pButton type="button" [outlined]="true" [text]="true" [severity]="'primary'" [size]="'small'"
              [disabled]="!invitationId || invitationActionPending"
              (click)="respondToEventInvitation($event, 'accept')">
        {{ 'common.confirm' | translate }}
      </button>
      <button pButton type="button" [outlined]="true" [text]="true" [severity]="'secondary'" [size]="'small'"
              [disabled]="!invitationId || invitationActionPending"
              (click)="respondToEventInvitation($event, 'deny')">
        {{ 'common.reject' | translate }}
      </button>
    </div>
    <div *ngIf="isPendingParticipationRequest" class="mt-2 flex gap-2">
      <button pButton type="button" [outlined]="true" [text]="true" [severity]="'primary'" [size]="'small'"
              [disabled]="!participationRequestId || invitationActionPending"
              (click)="respondToParticipationRequest($event, 'approve')">
        {{ 'common.confirm' | translate }}
      </button>
      <button pButton type="button" [outlined]="true" [text]="true" [severity]="'secondary'" [size]="'small'"
              [disabled]="!participationRequestId || invitationActionPending"
              (click)="respondToParticipationRequest($event, 'reject')">
        {{ 'common.reject' | translate }}
      </button>
    </div>
  </div>
</article>
